import { classes, BREAKPOINT } from '../constants';
import ScrollTo from '../utils/scrollto';
import sticky from '../libs/jquery.sticky';

const STICKY = $('[data-js-product-nav]');
const $parent = STICKY.parent();

window.onload = () => {
  if (STICKY.length) {
    initSticky();
  }
};

if (STICKY.length) {
  const breakpoint = STICKY.data('js-sticky-breakpoint')
    ? STICKY.data('js-sticky-breakpoint')
    : '';

  window.addEventListener('resize', initSticky);

  if (breakpoint) {
    if (Modernizr.mq('(min-width: ' + BREAKPOINT[breakpoint] + 'px)')) {
      initSticky();
    }
  } else {
    initSticky();
  }
}

function initSticky() {
  const currentYPosition = window.scrollY;
  let limit_bottom =
    $(document).height() - ($parent.outerHeight() + $parent.offset().top);
  STICKY.unstick();
  STICKY.sticky({
    topSpacing: 0,
    bottomSpacing: limit_bottom,
  });
  window.scrollTo({
    top: currentYPosition,
    behavior: 'instant',
  });
}

function getTabsToExpand(el) {
  let prevSibling = el.previousElementSibling;
  let siblings = [];
  while (prevSibling) {
    if (
      prevSibling.tagName.toLowerCase() === 'clover-accordion-heading' &&
      prevSibling.getAttribute('data-js-auto-open') === 'true'
    ) {
      siblings.push(prevSibling);
    }
    prevSibling = prevSibling.previousElementSibling;
  }
  return siblings;
}

export function handleNavChange(id) {
  if ($(`[data-js-product-nav] a[href="#${id}"]`)) {
    $('[data-js-product-nav] li').each((i, item) =>
      item.classList.remove(classes.active)
    );
    $(`[data-js-product-nav] a[href="#${id}"]`)
      .parent()
      .addClass(classes.active);
  }
}

function goToAnchor(id, isMobile) {
  let tab = document.querySelector(`[data-id=${id}]`);
  let siblingsToOpen = getTabsToExpand(tab);

  if (tab) {
    tab.setAttribute('expanded');
  }
  if (siblingsToOpen) {
    for (let i = 0; i < siblingsToOpen.length; i++) {
      siblingsToOpen[i].setAttribute('expanded');
      siblingsToOpen[i].setAttribute('data-js-auto-open', false);
    }
  }
  setTimeout(() => {
    let offset = isMobile ? 160 : 140;
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $(tab).offset().top - offset, //sticky nav height
      },
      250
    );
  }, 400);

  setTimeout(() => {
    handleNavChange(id);
  }, 1000); // hack so that other event listeners setting active button have fired
}

window.addEventListener('tabexpanded', (e) => {
  handleNavChange(e.target.getAttribute('data-id'));
});

$('[data-js-product-link]').each((i, el) => {
  $(el).on('click', (e) => {
    e.preventDefault();
    goToAnchor(e.target.getAttribute('href').substr(1), false);
  });
});

STICKY.find('a[href][data-js-back-to-top]').each((i, el) => {
  $(el).on('click', (e) => {
    e.preventDefault();
    $([document.documentElement, document.body]).animate(
      {
        scrollTop: $('#content').offset().top,
      },
      250
    );
  });
});

STICKY.find('select').on('change', (e) => {
  goToAnchor(e.target.value, true);
});
